import Vue from 'vue';
import main from './Main.vue';
import Router from '@/router';
import store from '@/store';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import { VUE_INSTANCE_NAME } from '@/constants';
import '@/assets/font/NotoSansKR.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/plugins';

Vue.config.productionTip = false;

export default class Main {
  constructor(routes) {
    this.vue = this.getInstance(routes);
  }

  async getInstance(routes) {
    const vue = new Vue({
      store,
      i18n: await i18n,
      router: await new Router(routes, store).router,
      vuetify: await vuetify,
      render: h => h(main),
    });
    window[VUE_INSTANCE_NAME] = vue;
    return vue;
  }
}
